import {
	JIRASERVICEMANAGEMENT,
	type Solutions,
} from '@atlassian/jira-common-constants/src/solutions-types.tsx';
import getApplicationSubProduct from '../get-application-sub-product/index.tsx';

const getApplicationSolutions = (): Solutions[] | undefined =>
	getApplicationSubProduct() === 'serviceDesk' ? [JIRASERVICEMANAGEMENT] : undefined;

export default getApplicationSolutions;
